


export function InstrucoesTratamento() {


    return (

        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant)</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados das obras em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Tratamento.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">3.</span> Proceda à seriação de peças a tratamento por referência de peça.</div>

            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  No ficheiro de “Expedição”, que deve ser sempre atualizado consoante as entradas/saídas da estante,
                introduza a obra no respetivo local para o destinado tratamento.</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">5.</span> Embale e deposite na prateleira de tratamento com identificação do mesmo.</div>
            <hr className="mb-5" />
        </div>

    )

} 